// Legacy JS module (verbatim PrivacyPolicy content factory), no types: typed loosely below.
import privacyPageContentDefault from 'root/src/client/web/static/PrivacyPolicy/pageContent';
import { LegalPageLayout } from 'root/src/client/v2/_pages/legal/redesign/LegalPageLayout';
import { LegalProse } from 'root/src/client/v2/_pages/legal/redesign/LegalProse';
import { LegalSection } from 'root/src/client/v2/_pages/legal/redesign/LegalSection';
import { LegalTableOfContents } from 'root/src/client/v2/_pages/legal/redesign/LegalTableOfContents';
import { legalClasses } from 'root/src/client/v2/_pages/legal/redesign/legalClasses';
const privacyPageContent = privacyPageContentDefault;
// Privacy Policy. REUSES the legacy `PrivacyPolicy/pageContent` factory verbatim (legal text is
// legally significant, see docs/redesign.md), fed the redesign `legalClasses` map, and the legacy
// `Anchors` TOC (via LegalTableOfContents) shown as a sticky sidebar on large screens. The render
// mirrors the legacy index: each entry is a `<section id={id}>` with an optional `<h3>` then the body.
export const RedesignPrivacyPolicyPage = () => {
    const sections = privacyPageContent(legalClasses);
    return (<LegalPageLayout title="Privacy Policy" tableOfContents={(<LegalProse className="text-sm">
					<LegalTableOfContents />
				</LegalProse>)}>
			<LegalProse definitionStrong>
				{sections.map(({ id, title, text }) => (<LegalSection key={id !== null && id !== void 0 ? id : String(title)} id={id} title={title}>
						{text}
					</LegalSection>))}
			</LegalProse>
		</LegalPageLayout>);
};
